import type { CatalogProps } from '../index';
import { BuyLink, ProductGrid, Quote, TplFooter, TplHeader, TplRoot, money, splitProducts } from '../shared';

/** Cyber Noir — minimalismo escuro, luzes ciano, micro-bordas. SaaS / automações / infoproduto. */
export default function Catalog({ data, apiBase }: CatalogProps) {
  const { store, products } = data;
  const { feature, grid } = splitProducts(store, products);

  return (
    <TplRoot>
      <TplHeader store={store} apiBase={apiBase} suffix=".OS" links={['Módulos', 'Integrações', 'Resultados']} />

      <section className="relative max-w-4xl mx-auto px-4 pt-16 pb-10 text-center">
        <span className="inline-block text-[11px] uppercase tracking-[0.3em] text-tertiary font-bold mb-4">
          Sistema de escala digital
        </span>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight leading-[1.1]">
          {store.tagline ?? (
            <>
              Automatize a sua operação com <span className="text-tertiary">{store.name}</span>.
            </>
          )}
        </h1>

        {/* VSL-style player */}
        <div className="mt-8 rounded-2xl border border-tertiary/20 bg-black/50 overflow-hidden shadow-[0_0_60px_-12px_rgba(76,215,246,0.3)]">
          <div className="aspect-video bg-gradient-to-br from-tertiary/10 via-white/[0.03] to-transparent flex items-center justify-center relative">
            <span className="w-16 h-16 rounded-full bg-tertiary/90 text-black flex items-center justify-center shadow-[0_0_30px_rgba(76,215,246,0.6)]">
              <span className="material-symbols-outlined text-3xl">play_arrow</span>
            </span>
            <span className="absolute bottom-3 left-3 text-[11px] font-mono text-tertiary/80">● APRESENTAÇÃO · vídeo em breve</span>
          </div>
        </div>

        {feature ? (
          <div className="mt-8 flex flex-col items-center gap-2">
            <BuyLink href={`/p/${feature.slug}`}>Quero acesso imediato</BuyLink>
            <span className="text-sm text-white/40">{feature.name} · {money(feature.amount)}</span>
          </div>
        ) : null}
      </section>

      <main className="max-w-5xl mx-auto px-4 pb-8 flex flex-col gap-12">
        {grid.length ? (
          <div>
            <p className="text-center text-[11px] uppercase tracking-widest text-white/40 font-bold">O que está incluído</p>
            <h2 className="text-center text-2xl font-black tracking-tight mt-1 mb-6">Módulos do sistema</h2>
            <ProductGrid products={grid} cols={3} cardCta="Abrir" />
          </div>
        ) : null}
        <Quote store={store} />
      </main>

      <TplFooter store={store} />
    </TplRoot>
  );
}
